import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { fieldErrorStyle } from '../Form/Field/FieldError.css';

type Props = ComponentPropsWithRef<'p'>;

export const ErrorMessage = ({ ...delegated }: Props) => {
  return <p {...delegated} className={clsx(fieldErrorStyle, delegated.className)} role={delegated.role ?? 'alert'} />;
};
